module.exports = __webpack_public_path__ + "static/media/icon_page_not_found.809b54c1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Containers/NoMatch/imgs/icon_page_not_found.svg
// module id = 821
// module chunks = 0